// extracted by mini-css-extract-plugin
module.exports = {"container":"Payment_Success_container__1n2ef","start":"Payment_Success_start__3sBAf"};